import ConfirmationModal, { IConfirmationModalProps } from './ConfirmationModal';

export { ConfirmationModal };
export type { IConfirmationModalProps };
export default ConfirmationModal;
